import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Input, Typography } from '@lyearn/ui';
import { ListWithTempId } from '@/hooks/useList/useListWithTempId';
import { ScorecardQuestionInput } from '@/types/schema';

import { isQuestionTextEmpty } from '../../../../views/ScorecardCreator/utils';

function TitleInput({
  error,
  question,
  onChange,
}: {
  error?: string;
  question: ListWithTempId<ScorecardQuestionInput>;
  onChange: (item: ListWithTempId<ScorecardQuestionInput>) => void;
}) {
  const { t } = useTranslation();

  const { text } = question;

  const showError = Boolean(error && isQuestionTextEmpty(text));

  return (
    <Box className="mb-20">
      <Input
        className="w-full"
        error={showError}
        placeholder={t('Scorecard:QuestionPlaceholder')}
        size="large"
        value={text}
        onChange={(event) => onChange({ ...question, text: event.target.value })}
      />
      {showError ? (
        <Typography className="mt-8 ms-8" color="text-text-error" variant="body-short-03">
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}

export default TitleInput;
